import React, { useState, useEffect, useRef } from "react";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import useTable from "../useTable";
import { Dimmer } from "../spinner";
import { Mensaje, MensajeSiNo } from "../mensajes";
import axios from "axios";
import { ActualizarCatgProgramatica } from "./modalActualizarCatgProgramarica";

const TablaCatgProgramaticas = (props) => {
  var op = require("../../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  let municipios = [];

  const headCells = [
    {
      id: "1",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "CATEGORIA PROGRAMATICA",
      textAlign: "center",
    },
    {
      id: "2",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "DESCRIPCIÓN",
      textAlign: "center",
    },
    {
      id: "3",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "CÓDIGO",
      textAlign: "center",
    },
    {
      id: "opciones",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: " OPCIONES",
      textAlign: "center",
    },
  ];

  const [mostrar2, setMostrar2] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [operacion, setOperacion] = useState(0);
  const [categoria, setCategoria] = useState();
  const [unidad, setUnidad] = useState([]);
  const txtBuscador = useRef();
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const { TblContainer, TblHead, recordsAfterPagingAndSorting, TblPagination } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else
          return items.filter((x) => {
            if (
              x.idcategoriaprogramatica.includes(target.value) ||
              x.descripcion
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              x.categoriaprogramatica
                .toLowerCase()
                .includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
      },
    });
  };

  const SeleccionarRegistros = () => {
    setActivate(true);

    let campos =
      "idcategoriaprogramatica, trim(descripcion)  AS descripcion, categoriaprogramatica";
    let nomtab = "categoriaprogramatica";
    let nomid = "idefiscal";

    let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${idefiscal}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setRecords(response.data);
          txtBuscador.current.focus();
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const SelectCategoriaProgramatica = (id, ope) => {
    setActivate(true);

    let campos = "*";
    let nomtab = "categoriaprogramatica";
    let nomid = "idcategoriaprogramatica";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idcategoriaprogramatica > 0) {
            setCategoria(response.data);
            SelectUnidadEjecutora(response.data, ope);
          } else {
            setCategoria();
            SelectUnidadEjecutora(response.data, ope);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const SelectUnidadEjecutora = (data, ope) => {
    let endpoint = `${op.conexion}/api/presupuesto/consultarunidadejecutora?id=${data.idcoordinacion}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          if (response.data.idcoordinacion > 0) {
            setUnidad(response.data);
            ConsultaUnidadxCuenta(data, ope);
          } else {
            setUnidad([]);
            ConsultaUnidadxCuenta(data, ope);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const ConsultaUnidadxCuenta = (data, ope) => {
    let endpoint = `${op.conexion}/api/presupuesto/consultaxcuenta?id=${data.idcategoriaprogramatica}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          if (ope === 2) {
            if (response.data.idcuenta > 0) {
              setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto:
                  "Error, La categoria no se puede editar porque ya fue utilizada en cuentas presupuestaria!",
                icono: "error",
              });
            } else {
              setMostrar2(true);
            }
          } else {
            setMostrar2(true);
          }

          setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const handleCloseSi = () => {
    setActivate(false);
  };

  const gestionarActuProgramatica = (op, id) => (e) => {
    if (op === 4) {
      setOperacion(4);
      SelectCategoriaProgramatica(id, op);
    } else if (op === 1) {
      setOperacion(op);
      setMostrar2(true);
    } else if (op === 2) {
      setOperacion(op);
      SelectCategoriaProgramatica(id, op);
    } else if (op === 3) {
      setOperacion(op);
      SelectCategoriaProgramatica(id, op);
    }
  };

  useEffect(() => {
    SeleccionarRegistros();
    setActivate(true);
  }, []);

  const handleCancelar = () => {
    setMostrar2(false);
  };

  return (
    <div className="h-100 w-100">
      <div className="row col-md-12 py-4 m-0">
        <div className="row col-md-12 py-4 m-0">
          <div className="col-md-8 py-4 mx-auto">
            <div className="col-12 p-2">
              <div className="row col-12 d-flex justify-content-between">
                <input
                  type="text"
                  className=" col-3 form-control form-control-sm rounded-pill"
                  ref={txtBuscador}
                  onChange={handleSearch}
                  placeholder="Buscar"
                />
                <div className="col-3 d-flex justify-content-end">
                  <button
                    onClick={gestionarActuProgramatica(1, "")}
                    style={{ marginBottom: "5px" }}
                    className="btn btn-sm btn-primary rounded-circle"
                  >
                    <i className="fas fa-plus"></i>{" "}
                  </button>
                </div>
              </div>
            </div>
            <div className="col-md-12 m-0">
              <TblContainer>
                <TblHead />
                <TableBody>
                  {records &&
                    recordsAfterPagingAndSorting().map((item, index) => (
                      <TableRow key={index} style={{ padding: "0" }}>
                        <TableCell
                          className="align-baseline"
                          style={{
                            textAlign: "center",
                            alignItems: "center",
                            width: "100px",
                          }}
                        >
                          {item.categoriaprogramatica}
                        </TableCell>
                        <TableCell
                          className="align-baseline"
                          style={{
                            textAlign: "center",
                            alignItems: "center",
                            width: "300px",
                          }}
                        >
                          {item.descripcion}
                        </TableCell>
                        <TableCell
                          className="align-baseline"
                          style={{
                            textAlign: "center",
                            alignItems: "center",
                            width: "50px",
                          }}
                        >
                          {item.idcategoriaprogramatica}
                        </TableCell>
                        <TableCell
                          className="align-baseline"
                          style={{
                            textAlign: "center",
                            alignItems: "center",
                            width: "50px",
                          }}
                        >
                          <button
                            onClick={gestionarActuProgramatica(
                              4,
                              item.idcategoriaprogramatica
                            )}
                            className="btn btn-sm mx-1 btn-info rounded-circle"
                          >
                            <i className="fas fa-eye"></i>{" "}
                          </button>
                          <button
                            onClick={gestionarActuProgramatica(
                              2,
                              item.idcategoriaprogramatica
                            )}
                            className="btn btn-sm mx-1 btn-warning rounded-circle"
                          >
                            <i className="fa fa-edit"></i>{" "}
                          </button>
                          <button
                            onClick={gestionarActuProgramatica(
                              3,
                              item.idcategoriaprogramatica
                            )}
                            className="btn btn-sm mx-1 btn-danger rounded-circle"
                          >
                            <i className="fa fa-trash"></i>{" "}
                          </button>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </TblContainer>
              <TblPagination />
            </div>
          </div>
        </div>
      </div>
      <ActualizarCatgProgramatica
        show={mostrar2}
        operacion={operacion}
        categoria={categoria}
        unidad={unidad}
        onHideCancelar={handleCancelar}
        onHideRenderizar={SeleccionarRegistros}
      />

      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
      <Dimmer active={activate} />
    </div>
  );
};
export default TablaCatgProgramaticas;



// WEBPACK FOOTER //
// ./src/components/presupuesto/tablaCategoriasProgramaticas.js